import { Component, Output, EventEmitter, OnInit, HostListener } from '@angular/core';
import { environment } from 'src/environments/environment';
// import { scrollTo } from 'scroll-js';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Utils } from 'src/app/utils/utilities';

@Component({
  selector: 'zip-co-slide-menu',
  templateUrl: './slide-menu.component.html',
  styleUrls: ['./slide-menu.component.scss'],
})
export class SlideMenuComponent implements OnInit {
  @Output()
  public close = new EventEmitter();
  public overflow: boolean;
  public signinUrl: string;
  public signUpUrl: string;
  public merchantSigninUrl: string;
  public showZipBiz: boolean;
  public branchId = '';
  public os;
  public advertId;
  private content: HTMLElement;

  constructor(private route: ActivatedRoute, private router: Router) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.url.includes('/zipbusiness')) {
          this.signinUrl = `${environment.auth.zipBusinessLogin}`;
          this.signUpUrl = `${environment.auth.zipBusinessSignup}`;
          this.showZipBiz = true;
        } else {
          this.signinUrl = environment.auth.customerLogin;
          this.merchantSigninUrl = environment.auth.merchantLogin;
          this.showZipBiz = false;
        }
      }
    });
  }

  ngOnInit() {
    this.content = document.getElementById('content');
    this.checkOverflow();
  }

  public get shopLink(): string {
    return environment.shopUrl.shopRouteLink;
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event?: any) {
    if (this.content.scrollTop === this.content.scrollHeight - this.content.offsetHeight) {
      this.overflow = false;
    } else {
      this.overflow = true;
    }
  }

  checkOverflow() {
    if (
      this.content.offsetHeight < this.content.scrollHeight ||
      this.content.offsetWidth < this.content.scrollWidth
    ) {
      this.overflow = true;
    } else {
      this.overflow = false;
    }
  }

  scrollDown() {
    this.content.scroll({
      top: this.content.scrollHeight - this.content.offsetHeight,
      behavior: 'smooth',
    });
    // scrollTo(this.content, {
    //   top: this.content.scrollHeight - this.content.offsetHeight,
    //   duration: 150,
    // });
  }

  scrollUp() {
    this.content.scroll({
      top: 0,
      behavior: 'smooth',
    });
    // scrollTo(this.content, { top: 0, duration: 150 });
    setTimeout(() => {
      this.checkOverflow();
    }, 200);
  }
}
